import CheckoutState from "@vue-storefront/core/modules/checkout/types/CheckoutState";

const checkoutInitialState: CheckoutState = {
  order: {},
  cutleryQty: [],
  personalDetails: {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    password: '',
    createAccount: false
  },
  shippingDetails: {
    firstName: '',
    lastName: '',
    country: '',
    street: '',
    house: '',
    apartment: '',
    city: '',
    state: '',
    region_id: 0,
    zipCode: '',
    phoneNumber: '',
    shippingMethod: '',
    shippingCarrier: '',
    comment: '',
    longitude: '',
    latitude: '',
    api_details: '',
    default_shipping: false
  },
  firstUserShippingDetails: {
    firstName: '',
    lastName: '',
    country: '',
    street: '',
    house: '',
    apartment: '',
    city: '',
    state: '',
    region_id: 0,
    zipCode: '',
    phoneNumber: '',
    shippingMethod: '',
    comment: ''
  },
  deliveryTime: [],
  comment: null,
  paymentDetails: {
    banknoteDenomination: '',
    firstName: '',
    lastName: '',
    company: '',
    country: '',
    streetAddress: '',
    houseNumber: '',
    apartmentNumber: '',
    city: '',
    state: '',
    region_id: 0,
    zipCode: '',
    phoneNumber: '',
    taxId: '',
    paymentMethod: '',
    paymentMethodAdditional: {}
  },
  isThankYouPage: false,
  addNewAddress: false,
  paymentFailedMessage: '',
  modifiedAt: 0
};

export default checkoutInitialState;
